var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button-element",attrs:{"color":_vm.color,"depressed":"","loading":_vm.loading,"text":_vm.secondary,"block":_vm.block},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(`mdi-${_vm.icon}`)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }